export const setEpicorToken = (token) => {
  localStorage.setItem("epicor_token", token);
};

export const getEpicorToken = () => {
  return localStorage.getItem("epicor_token");
};

export const isEpicorLoggedIn = () => {
  return !!getEpicorToken();
};

export const logoutEpicor = () => {
  localStorage.removeItem("epicor_token");
};
